<template>
  <naj-modal
    ref="renderAttachmentModal"
    :width="1000"
    :footer="true"
    :close-button="true"
    :show-footer-close-button="true"
    :title="attachmentFile.name"
    @onClose="closeRenderAttachmentModal"
  >
    <div
      v-if="loading"
      class="loader-holder"
    >
      <naj-loader></naj-loader>
    </div>
    <v-row
      v-else
      class="attachment-row"
    >
      <image-editor
        v-if="attachmentFile.isImage"
        :image-url="fileUrl"
        :image-name="attachmentFile.name"
      ></image-editor>

      <div
        v-else
        class="pdf-container"
      >
        <div class="pdf-wrapper">
          <div class="pdf-holder">
            <embed
              class="pdf-viewer"
              :src="fileUrl"
            >
          </div>
        </div>
      </div>
    </v-row>
  </naj-modal>
</template>

<script>
import { getBlobUrl } from '@/modules/lawsuit/helpers/utils';

import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('CasesModule');

import ImageEditor from './image-editor';

export default {
  name: 'RenderAttachmentModal',
  components: { ImageEditor },
  props: {
    attachmentFile: {
      type: Object,
      required: true,
    },
    modalVisibility: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      document: null,
    };
  },
  computed: {
    fileUrl() {
      return getBlobUrl(this.document, this.attachmentFile.isImage);
    },
  },
  watch: {
    modalVisibility(newValue) {
      if (newValue) {
        this.$refs.renderAttachmentModal.show();
        if (this.attachmentFile.sharePointId) {
          this.getAttachmentDocument();
        }
      } else {
        this.$refs.renderAttachmentModal.close();
      }
    },
  },
  mounted() { },
  methods: {
    ...mapActions(['getTrustedSourceAttachment']),
    closeRenderAttachmentModal() {
      this.resetData();
      this.$emit('modalClose');
    },
    resetData() {
      this.document = null;
      this.loading = false;
    },
    getAttachmentDocument() {
      this.loading = true;
      this.getTrustedSourceAttachment(this.attachmentFile.sharePointId)
        .then((attachment) => {
          const contentType = this.attachmentFile.isImage ? 'image/png' : 'application/pdf';
          this.document = `data:${contentType};base64,${attachment}`;
        })
        .finally(
          () => (this.loading = false)
        );
    },
  },
};
</script>

<style lang="scss" scoped>
.attachment-row {
  justify-content: center;
}

.attachment-file-viewer {
  height: 100%;
  width: 100%;
}
.preview-holder {
  display: block !important;
  height: 600px;
  width: 100%;
}

.pdf-container {
  height: 100%;
  .pdf-wrapper {
    height: 100%;
    position: relative;
    min-height: 150px;
    .pdf-holder {
      height: inherit;
      text-align: center;
      line-height: 1;
      .pdf-viewer {
        max-height: 100%;
        display: inline-block;
      }
    }
  }
}

embed {
  width: 100%;
  height: 100%;
  min-height: 500px !important;
}
</style>